__webpack_require__.nmd = (module) => {
	module.paths = [];
	if (!module.children) module.children = [];
	return module;
};